var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-screen-area"},[(_vm.img)?_c('img',{staticClass:"data-screen-img",attrs:{"src":_vm.img,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }